import script from "./OnboardingAiOkrIntervalStep.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiOkrIntervalStep.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiOkrIntervalStep.vue?vue&type=style&index=0&id=2face231&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2face231"]])

export default __exports__